// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16wBC","content":"styles_content__3kEdg"};